import React from 'react';
import PropTypes from 'prop-types';
import { texts } from 'utils/languages/fr';

import CustomDialogTitle from 'components/CustomDialogTitle/CustomDialogTitle';
import { Dialog, DialogContent, Link } from '@mui/material';
import { ucFirst } from 'utils/helpers';

const ContactDialog = ({ open, onCancel }) => (
    <Dialog open={open}>
        <CustomDialogTitle handleClose={onCancel} title={ucFirst(texts.CONTACT).replace('.', '')} />
        <DialogContent>
            <p>
                Email :{' '}
                <Link
                    sx={{ textDecoration: 'none', color: 'primary.main' }}
                    href="mailto:contact@petech.fr"
                    target="_blank"
                    rel="noreferrer"
                >
                    contact@petech.fr
                </Link>
            </p>
            <p>Téléphone : 01 42 89 12 87</p>
        </DialogContent>
    </Dialog>
);

ContactDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
};

export default ContactDialog;
